module.exports = __webpack_public_path__ + "static/media/lease.0f170850.png";